"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomColumnMenu = void 0;
const React = __importStar(require("react"));
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const ll_1 = require("../../languages/ll");
const styled_components_1 = __importDefault(require("styled-components"));
class CustomColumnMenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.onToggleColumn = (id) => {
            if (this.state.columns) {
                this.setState({
                    columns: this.state.columns.map((column, idx) => {
                        return idx === id
                            ? { ...column, hide: column.hide ? false : true }
                            : column;
                    })
                });
            }
        };
        this.onReset = (event) => {
            event.preventDefault();
            if (this.props.columns) {
                this.setState({ columns: [...this.props.columns] }, () => this.onSubmit());
            }
        };
        this.onSubmit = (event) => {
            if (event) {
                event.preventDefault();
            }
            if (this.props.onColumnsSubmit && this.state.columns) {
                this.props.onColumnsSubmit(this.state.columns);
            }
            if (this.props.onCloseMenu) {
                this.props.onCloseMenu();
            }
        };
        this.onMenuItemClick = () => {
            const value = !this.state.columnsExpanded;
            this.setState({
                columnsExpanded: value,
                filterExpanded: value ? false : this.state.filterExpanded
            });
        };
        this.onFilterExpandChange = (value) => {
            this.setState({
                filterExpanded: value,
                columnsExpanded: value ? false : this.state.columnsExpanded
            });
        };
        this.state = {
            columns: this.props.columns || [],
            columnsExpanded: false,
            filterExpanded: false
        };
    }
    render() {
        if (this.state.columns) {
            const { ignoreColumns } = this.props;
            const oneVisibleColumn = this.state.columns &&
                this.state.columns.filter(c => c.hide !== true).length === 1;
            return (React.createElement(ll_1.LLConsumer, null, ({ languageId }) => (React.createElement("div", { className: this.props.className },
                this.props.sortable ? (React.createElement(kendo_react_grid_1.GridColumnMenuSort, Object.assign({}, this.props))) : null,
                this.props.filterable ? (React.createElement(kendo_react_grid_1.GridColumnMenuFilter, Object.assign({}, this.props, { onExpandChange: this.onFilterExpandChange, expanded: this.state.filterExpanded }, (this.props.filterProps || {})))) : null,
                React.createElement(kendo_react_grid_1.GridColumnMenuItemGroup, null,
                    React.createElement(kendo_react_grid_1.GridColumnMenuItem, { title: ll_1.ll({ key: "Columns", languageId }), iconClass: "k-i-columns", onClick: this.onMenuItemClick }),
                    React.createElement(kendo_react_grid_1.GridColumnMenuItemContent, { show: this.state.columnsExpanded },
                        React.createElement("div", { className: "k-column-list-wrapper" },
                            React.createElement("form", { onSubmit: this.onSubmit, onReset: this.onReset },
                                React.createElement("div", { className: "k-column-list" }, this.state.columns &&
                                    this.state.columns.map((column, idx) => {
                                        return !ignoreColumns ||
                                            (ignoreColumns &&
                                                ignoreColumns.indexOf(column.field || "") === -1) ? (React.createElement("div", { key: idx, className: "k-column-list-item" },
                                            React.createElement("span", null,
                                                React.createElement(kendo_react_inputs_1.Checkbox, { label: column.localize ===
                                                        false
                                                        ? column.title
                                                        : ll_1.ll({
                                                            key: column.title ||
                                                                column.field ||
                                                                "",
                                                            languageId
                                                        }), disabled: column.hide !==
                                                        true &&
                                                        oneVisibleColumn, value: column.hide !== true, onChange: this.onToggleColumn.bind(this, idx) })))) : null;
                                    })),
                                React.createElement("div", { className: "k-columnmenu-actions" },
                                    React.createElement("button", { type: "reset", className: "k-button" }, ll_1.ll({ key: "Cancel", languageId })),
                                    React.createElement("button", { className: "k-button k-primary" }, ll_1.ll({ key: "Save", languageId })))))))))));
        }
        else {
            return null;
        }
    }
}
exports.CustomColumnMenu = styled_components_1.default(CustomColumnMenuComponent) `
   text-align: left;
`;
//# sourceMappingURL=customColumnMenu.js.map